import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";
import { normalizeApiMessage } from "lib/i18n/apiMessage";

function normalizeApiMessageWithFallbackKey(
  payload,
  fallbackMessage,
  fallbackKey,
) {
  const normalized = normalizeApiMessage(payload, fallbackMessage);
  return {
    ...normalized,
    messageKey: normalized.messageKey || fallbackKey || "",
  };
}

export async function deleteProject(projects, user_id) {
  if (!user_id) {
    return {
      success: false,
      ...normalizeApiMessageWithFallbackKey(
        { message: "Sign-in is required." },
        "Sign-in is required.",
        "api.auth.token.missing",
      ),
    };
  }

  if (!Array.isArray(projects) || projects.length < 1) {
    return {
      success: false,
      ...normalizeApiMessageWithFallbackKey(
        { message: "Invalid project selection." },
        "Invalid project selection.",
        "api.project.delete.validation.invalidSelection",
      ),
    };
  }

  try {
    const path = `${BACKEND_URL}/project/deleteProject`;
    const res = await authFetch(
      path,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ids: projects }),
      },
      {
        refreshUrlIncludes: "auth/refresh",
      },
    );

    const result = await res.json().catch(() => null);

    if (!result) {
      return {
        success: false,
        ...normalizeApiMessageWithFallbackKey(
          { message: "Failed to parse server response." },
          "Failed to parse server response.",
          "api.common.serverError",
        ),
      };
    }

    if (!res.ok || result?.success !== true) {
      if (res.status === 401) {
        return {
          success: false,
          ...normalizeApiMessageWithFallbackKey(
            result,
            "Session expired. Please sign in again.",
            "api.auth.token.expired",
          ),
        };
      }

      const fallbackKey =
        res.status === 404
          ? "api.project.delete.notFound"
          : res.status === 400
            ? "api.project.delete.validation.invalidRequest"
            : "api.project.delete.failed";

      return {
        success: false,
        ...normalizeApiMessageWithFallbackKey(
          result,
          "Request failed.",
          fallbackKey,
        ),
      };
    }

    return {
      success: true,
      ...normalizeApiMessageWithFallbackKey(
        result,
        "Project deleted successfully.",
        "api.project.delete.success",
      ),
      new_last_selected_project: result.new_last_selected_project,
      new_last_selected_project_name: result.new_last_selected_project_name,
    };
  } catch (error) {
    console.error("deleteProject request failed:", error);
    return {
      success: false,
      ...normalizeApiMessageWithFallbackKey(
        { message: "Server request failed." },
        "Server request failed.",
        "api.common.networkError",
      ),
    };
  }
}
